// Sauvegarde rapide du panier depuis le cart drawer — chargé sur TOUTES les pages.
// Volontairement séparé de saved-carts.js (panneau complet, ~5,6 Ko gzip) qui n'est
// chargé que sur la page panier et la page « Mes paniers enregistrés ».

// Sauvegarde rapide depuis le cart drawer (pas de formulaire : prompt de nom).
class SavedCartsQuickSave extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.saved-carts-quick__button');
    if (this.button) this.button.addEventListener('click', () => this.save());
  }

  defaultName(now = new Date()) {
    const d = String(now.getDate()).padStart(2, '0'),
          m = String(now.getMonth() + 1).padStart(2, '0');
    return `Panier du ${d}/${m}/${now.getFullYear()}`;
  }

  feedback(message) {
    let zone = this.querySelector('.saved-carts-quick__message');
    if (!zone) {
      zone = document.createElement('p');
      zone.className = 'saved-carts-quick__message';
      this.appendChild(zone);
    }
    zone.textContent = message;
  }

  async save(overwrite) {
    const config = window.savedCartsConfig || {};
    const apiBase = config.apiBase || '/a/espace-acheteurs/api/carts';
    let name = this.pendingName;
    if (!name) {
      name = window.prompt(window.savedCartsTokens.quick_save_prompt, this.defaultName());
      if (name === null) return;
      name = name.trim() || this.defaultName();
      this.pendingName = name;
    }
    this.button.disabled = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      const lines = (cart.items || []).map((item) => ({
        sku: item.sku,
        variant_id: item.variant_id || item.id,
        qty: item.quantity,
        title: item.product_title,
        unit_price_at_save: Math.round(item.price) / 100,
      }));
      if (!lines.length) { this.feedback(window.savedCartsTokens.empty_cart); return; }
      const response = await fetch(apiBase, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, lines, source: 'cart_page', overwrite: overwrite === true }),
      });
      const body = await response.json().catch(() => null);
      if (response.status === 409 && body && body.error === 'name_exists') {
        if (window.confirm(window.savedCartsTokens.replace_confirm.replace('##', name))) {
          await this.save(true);
        }
        return;
      }
      if (!response.ok || !body || !body.ok) {
        this.feedback((body && (body.message || body.error)) || window.savedCartsTokens.error);
        return;
      }
      this.feedback(window.savedCartsTokens.saved.replace('##', body.name));
    } catch (_e) {
      this.feedback(window.savedCartsTokens.error);
    } finally {
      this.pendingName = null;
      this.button.disabled = false;
    }
  }
}


if (!customElements.get('saved-carts-quick-save')) {
  customElements.define('saved-carts-quick-save', SavedCartsQuickSave);
}
